import PannelHeader from "../fragments/PannelHeader"
import Card from "./Card"

import classes from './ModalInnerWrapper.module.css'

const ModalInnerWrapper = ({children, closeModal, modalTitle, noOverflow, widthAuto, mode, setWidth, minHeight}) => {

    const closeModalHandler = () => {
        if (closeModal) {
            closeModal()
        }
    }


    return <Card>
        <div className={`${classes.container} ${noOverflow ? classes.no_overflow : ''} ${widthAuto ? classes.width_auto: ''} ${mode ? classes['mode_' + mode] : ''}`} style={{width: setWidth, minHeight: minHeight}}>
            <PannelHeader mode={mode}>
                <div className={classes.flex_container}>
                    {modalTitle && <h2>{modalTitle}</h2>}
                    {closeModal && 
                    <button onClick={closeModalHandler} className={classes.close_modal}>
                        <i className="ti ti-x"></i>
                        <span className="sr-only">close modal</span>
                    </button>}
                </div>               
            </PannelHeader>
            {children}
        </div>        
    </Card>
}

export default ModalInnerWrapper